import {dateUtils} from "../../utils/dateUtils"
import flowapis from "../../api/score"

export default {
    name: "ScoreData",
    data() {
        let year = new Date().getFullYear()
        let month = new Date().getMonth()+1
        month = month<10?'0'+month:month
        let day = new Date().getDate()
        day = day<10?'0'+day: day
        let thisDate = new Date().getFullYear()+"-"+month+'-'+day
        return {
            scrollHeight: 400,
            time: year +"-"+month,
            timeY: year+'',
            chooseType: 'month',
            weekStatistic: {},
            monthStatistic: {},
            yearStatistic: {},
            allStatistic: {},
            zaibaoStatistic: {},
            chartStatistic:{},
            customChartStatistic: {},
            projectNameArr: [],
            chooseProjectNames: [],
            dateRange: [year+'-01-01', thisDate]
        };
    },
    created() {
        let that = this;
        that.$nextTick(() => {
            that.getData()
            that.getChartDataMonth()
            // that.getChartDataYear()
            that.getProjectNameDistinct()
        });
    },
    beforeMounted() {
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        getData() {
            let that = this
            flowapis.getStatisticSb({}).then(res => {
                that.weekStatistic = res.weekStatistic
                that.monthStatistic = res.monthStatistic
                that.yearStatistic = res.yearStatistic
                that.allStatistic = res.allStatistic
                that.zaibaoStatistic = res.zaibaoStatistic
            })
        },
        getChartDataMonth() {
            let that = this
            flowapis.getStatisticSbTypeMonth({month:this.time}).then(res=>{
                that.chartStatistic = res
                that.updateChart()
            })
        },
        getChartDataYear() {
            let that = this
            flowapis.getStatisticSbTypeYear({year:this.timeY}).then(res=>{
                that.chartStatistic = res
                that.updateChart()
            })
        },
        getProjectNameDistinct() {
           let that = this
          flowapis.getProjectNameDistinct({}).then(res=>{
              that.projectNameArr = res
              for (let item of that.projectNameArr) {
                  that.chooseProjectNames.push(item.ProjectName)
              }
              // 默认统计一下
              that.getChartDataCustom()
          })
        },
        getChartDataCustom() {
          let that = this
          if(that.chooseProjectNames.length === 0) {
              for (let item of that.projectNameArr) {
                  that.chooseProjectNames.push(item.ProjectName)
              }
          }
          let params = {
              startTime: that.dateRange[0]+' 00:00:00',
              endTime: that.dateRange[1]+' 23:59:59',
              types: that.chooseProjectNames.join(',')
          }
          flowapis.getStatisticSbCustom(params).then(res=>{
              that.customChartStatistic = res
              that.updateCustomChart()
          })
        },
        updateCustomChart() {
            let that = this
            let dataArr = this.customChartStatistic
            let chart = {}
            chart = this.$root.echarts.init(
                document.getElementById('echarts2')
            )
            // 双环形图
            let inner = []
            let outer = []
            // 图例
            let nameArr = []
            let allTotal = 0
            let allPrice = 0
            for(let item of dataArr) {
                outer.push({
                    value: item.price,
                    name: item.ProjectName,
                    unit: '万元'
                })
                inner.push({
                    value: item.total,
                    name: item.ProjectName,
                    unit: '笔'
                })
                nameArr.push(item.ProjectName)
                allPrice += item.price
                allTotal += item.total
            }
            // 生成
            let option = {
                title: [{
                    text: `内环：共${allTotal}笔\n外环：共${allPrice}万元`,
                    top: 'center',
                    left: '33.5%',
                    textStyle: {
                        fontSize: 12,
                        color:'#2e8fe6',
                        lineHeight: 26,
                        fontWeight: 400
                    }
                }],
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                // color: ['#C6C83F', '#C6C840', '#C5C841', '#B9C555',
                //     '#B6C559','#B5C55B','#B2C45F','#B2C45F',
                //     '#AEC366','#A9C26F', '#A8C270','#A6C173',
                //     '#A0C07D', '#95BE90', '#91BD96','#90BD97',
                //     '#8DBC9D','#8ABBA0','#89BBA3','#86BAA8',
                //     '#84BAAA','#78B8BE','#74B7C5','#72B6C7',
                //     '#72B6C7','#67B4D9','#63B3E0','#62B3E1'],
                color: ['#4EAEEC','#50CEDC','#7BD285','#8086F1'],
                legend: {
                    show: true,
                    top: "center",
                    left: '70%',
                    data: nameArr,
                    itemWidth: 15,
                    itemHeight: 15,
                    padding: [0, 5],
                    itemGap: 10,
                    textStyle: {
                        color: '#b0b9cb'
                    },
                    formatter: function(name) {
                        return name
                    },
                },
                series: [
                    //最外层圆环，装饰用
                    {
                        name: '圆圈',
                        type: 'pie',
                        zlevel: 1,
                        silent: true,
                        radius: ['89%', '90%'],
                        center: ["40%", "50%"],
                        hoverAnimation: false,
                        color: "#7eb3fb",
                        label: {
                            normal: {
                                show: false
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[{
                            value: 1,
                            name: '',
                            itemStyle:{
                                normal: {
                                    color: '#99c3fc'
                                }
                            }
                        }]
                    },

                    {
                        name: '外环',
                        type: 'pie',
                        radius: ['60%', '85%'],
                        center: ["40%", "50%"],
                        startAngle: '240',
                        data: outer,
                        labelLine: {
                            normal: {
                                length: 20,
                                length2: 140,
                                lineStyle: {
                                    color: '#e6e6e6'
                                }
                            }
                        },
                        itemStyle: { // 此配置
                            normal: {
                                borderWidth: 2,
                                borderColor: '#fff',
                            },
                            emphasis: {
                                borderWidth: 0,
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                formatter: params => {
                                    return (
                                        params.value + '万元'
                                    );
                                },
                                fontSize: 12,
                                color: '#000',
                                // padding: [0, -130, 25, -130],
                            }
                        },
                    },

                    {
                        name: '内环',
                        type: 'pie',
                        radius: ['35%', '60%'],
                        center: ["40%", "50%"],
                        itemStyle: { // 此配置
                            normal: {
                                borderWidth: 2,
                                borderColor: '#fff',
                            },
                            emphasis: {
                                borderWidth: 0,
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                formatter: params => {
                                    return (
                                        params.value + '笔'
                                    );
                                },
                                fontSize: 12,
                                color: '#000',
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        startAngle: '230',
                        data: inner
                    }
                ]
            };
            chart.setOption(option)
        },
        updateChart(){
            let dataArr = this.chartStatistic
            let chart = {}
            chart = this.$root.echarts.init(
                document.getElementById("echarts1")
            );
            let projectArr = []
            let totalArr = []
            let priceArr = []
            for(let i=0;i<dataArr.length;i++){
                projectArr.push(dataArr[i].ProjectName)
                totalArr.push(dataArr[i].total)
                priceArr.push(dataArr[i].price)
            }
            // var colors = ['#d3dee5', '#ADC367'];

            let option = {
                // color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    data: ['数量', '金额']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: projectArr
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '数量',
                        min: 0,
                        position: 'left',
                        axisLine: {
                            lineStyle: {
                                // color: colors[0]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 次'
                        }
                    },
                    {
                        type: 'value',
                        name: '金额',
                        min: 0,
                        position: 'right',
                        axisLine: {
                            lineStyle: {
                                // color: colors[1]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 万元'
                        }
                    }
                ],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        data: totalArr,
                        barWidth: '12px',
                        itemStyle: {
                            normal: {
                                color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#fccb05'
                                }, {
                                    offset: 1,
                                    color: '#f5804d'
                                }]),
                                barBorderRadius: 12,
                            },
                        },
                    },
                    {
                        name: '金额',
                        type: 'bar',
                        barWidth: '12px',
                        itemStyle: {
                            normal: {
                                color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8bd46e'
                                }, {
                                    offset: 1,
                                    color: '#09bcb7'
                                }]),
                                barBorderRadius: 11,
                            }

                        },
                        yAxisIndex: 1,
                        data: priceArr
                    }
                ]
            };

            chart.setOption(option)
        },
        onMonthChange() {
            this.getChartDataMonth()
        },
        onYearChange() {
            this.getChartDataYear()
        },
        onChooseTypeChange() {
            if (this.chooseType === 'month') {
                this.onMonthChange()
            } else {
                this.timeY = this.time.split('-')[0]
                this.onYearChange()
            }
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height2 = $(".content-box .content .seach-container").height();
                var height = height1 - height2 - 112 - 40;
                this.scrollHeight = height;
            });
        }
    },
};
